import get from "lodash.get";
import ReactGA from "react-ga4";

import { gaCategory, gaTrackingId, shopId } from "config/const";
import { EventType } from "tracking";

export const sendGAEvent = (_lineId, _action, others = {}) => {
  const lineId = _lineId || "anonymous";
  const action = _action || "no_action";
  const otherLabel = (() => {
    const getOtherLabel = get(others, "label", "");
    if (!getOtherLabel) return "";
    if (String(getOtherLabel).startsWith("/")) return getOtherLabel;
    return `/${getOtherLabel}`;
  })();

  const label = `shop/${shopId}/customer/${lineId}${otherLabel}`;

  const event = {
    ...others,
    userId: `shop/${shopId}/user/${lineId}`,
    shop_id: shopId,
    client_id: lineId,
    referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
    title: action,
    category: `${gaCategory}/${shopId}`,
    action,
    label,
    value: 1,
  };

  console.log("ga", lineId, action, others);
  ReactGA.event({ ...event, shopId, lineId }, { send_to: gaTrackingId });
};

export function sendDeeplinkClickGa(lineId, from = "", target = "") {
  sendGAEvent(lineId, EventType.ClickDeeplink, { label: from });
  ReactGA.event(`from@${from || ""}@${target || ""}`);
}

export function sendAddToCartGa(lineId, options = {}) {
  const contentGroup1 = options.productId
    ? `product_id=${options.productId}`
    : undefined;
  const contentGroup2 = options.specId
    ? `spec_id=${options.specId}`
    : undefined;
  const contentGroup3 = options.quantity
    ? `quantity=${options.quantity}`
    : undefined;

  sendPageview(
    lineId,
    "add_to_cart",
    { contentGroup1, contentGroup2, contentGroup3 },
    { send_to: gaTrackingId },
  );
}

export function sendSendPurchaseGa(lineId, options = {}) {
  const contentGroup1 = undefined;
  const contentGroup2 = undefined;
  const contentGroup3 = undefined;

  sendPageview(lineId, "sendPurchase", {
    contentGroup1,
    contentGroup2,
    contentGroup3,
  });
}

export function sendInvoiceSendGa(lineId, options = {}) {
  const contentGroup1 = undefined;
  const contentGroup2 = undefined;
  const contentGroup3 = undefined;

  sendPageview(
    lineId,
    "invoice_send",
    { contentGroup1, contentGroup2, contentGroup3 },
    { send_to: gaTrackingId },
  );
}

export function sendSelectProductSpecGa(lineId, options = {}) {
  const contentGroup1 = options.productId
    ? `product_id=${options.productId}`
    : undefined;
  const contentGroup2 = options.specId
    ? `spec_id=${options.specId}`
    : undefined;
  const contentGroup3 = options.quantity
    ? `quantity=${options.quantity}`
    : undefined;

  sendPageview(
    lineId,
    "select_product_spec",
    { contentGroup1, contentGroup2, contentGroup3 },
    { send_to: gaTrackingId },
  );
}

export function sendPageview(_lineId, _ga, options = {}) {
  const lineId = _lineId || "anonymous";
  const ga = _ga || "no_action";
  const contentGroup1 = get(options, "contentGroup1");
  const contentGroup2 = get(options, "contentGroup2");
  const contentGroup3 = get(options, "contentGroup3");
  const contentGroup4 = get(options, "contentGroup4");

  const page = `/shop/${shopId}/user/${lineId}/action/${ga}`;
  const pageviewEvent = {
    hitType: "pageview",
    page,
    userId: `shop/${shopId}/user/${lineId}`,
    shop_id: shopId,
    client_id: lineId,
    referrer: `https://linebot/shop/${shopId}/user/${lineId}`,
    location:
      `https://linebot/shop/${shopId}/user/${lineId}/action/${ga}` ||
      window.location.href ||
      "",
    title: ga,
    contentGroup1,
    contentGroup2,
    contentGroup3,
    contentGroup4,
    content_group_1: contentGroup1,
    content_group_2: contentGroup2,
    content_group_3: contentGroup3,
    content_group_4: contentGroup4,
  };

  console.log("pageview", pageviewEvent);
  ReactGA.send(pageviewEvent, { send_to: gaTrackingId });
}

export function sendError(error, _lineId, _ga, options = {}) {
  const lineId = _lineId || "anonymous";
  const ga = _ga || "error";

  const page = `/shop/1/user/${lineId}/action/${ga}`;
  const pageviewEvent = {
    hitType: "pageview",
    page,
    userId: `shop/1/user/${lineId}`,
    shop_id: shopId,
    client_id: lineId,
    referrer: `https://linebot/shop/1/user/${lineId}`,
    location: `/shop/1/replyToken/${shopId}/action/error?message=${encodeURIComponent(
      error || "",
    )}`,
    title: ga,
  };

  console.log("pageview", pageviewEvent);
  ReactGA.send(pageviewEvent, { send_to: gaTrackingId });
}
